import { render, staticRenderFns } from "./Template-4.vue?vue&type=template&id=fd3265b8&scoped=true"
import script from "./Template-4.vue?vue&type=script&lang=js"
export * from "./Template-4.vue?vue&type=script&lang=js"
import style0 from "./Template-4.vue?vue&type=style&index=0&id=fd3265b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3265b8",
  null
  
)

export default component.exports